import type {
  EtcTicket,
  EtcTicketOperatorNote,
} from '#/components/ui/tickets/etc/model';
import { Center, Skeleton, Stack, Text, Timeline } from '@mantine/core';
import { useEtcTicket } from '#/components/ui/tickets/etc/endpoints/ticketsHooks';
import { formatDateTime } from '#/utils/DateUtil';
import { MarkdownNote } from './MarkdownNote';

const NotesList = ({ notes }: { notes: EtcTicketOperatorNote[] }) => {
  return (
    <Timeline bulletSize={12} lineWidth={2}>
      {notes
        .sort(({ createDateTime: dtA }, { createDateTime: dtB }) => {
          return +new Date(dtB) - +new Date(dtA);
        })
        .map((note) => (
          <Timeline.Item key={note.id} title={note.operator}>
            <MarkdownNote content={note.content} />
            <Text size="xs" c="dimmed" mt={2}>
              {formatDateTime(note.createDateTime)}
            </Text>
          </Timeline.Item>
        ))}
    </Timeline>
  );
};

export const EtcNotesList = ({ id }: { id: EtcTicket['id'] | undefined }) => {
  const { data, isLoading } = useEtcTicket(id);

  const notes = data?.operatorNotes ?? [];

  if (!id) {
    return null;
  }

  if (isLoading) {
    return (
      <Stack gap="md">
        {[1, 2, 3].map((i) => (
          <Stack key={i} gap={4} pl="md">
            <Skeleton height={14} width={80} />
            <Skeleton height={12} width="90%" />
            <Skeleton height={10} width={100} />
          </Stack>
        ))}
      </Stack>
    );
  }

  if (notes.length < 1) {
    return (
      <Center py="xl">
        <Text size="sm" c="dimmed">
          No notes yet
        </Text>
      </Center>
    );
  }

  return <NotesList notes={notes} />;
};

